(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/selectors/assets/javascripts/teams.js') >= 0) return;  svs.modules.push('/components/marketplace-data/selectors/assets/javascripts/teams.js');
"use strict";

const PAGE_SIZE = svs.components.marketplaceShared.sharedConstants.constants.PAGE_SIZE;
const groupTypeNames = svs.components.marketplaceData.constants.groupTypeNames;
const selectBrowseGamesResults = svs.components.marketplaceData.selectors.results.selectBrowseGamesResults;
const getTeams = _ref => {
  let Teams = _ref.Teams;
  return Teams.data.filter(team => {
    const isRemoved = Teams.removedTeams.indexOf(Number(team.id)) !== -1;
    const isPrivate = team.type === 'PRIVATE';
    return !isRemoved && isPrivate;
  });
};

const selectTeam = (state, _ref2) => {
  let id = _ref2.id;
  return state && state.Teams && !state.Teams.removedTeams.find(i => i === Number(id)) && state.Teams.data.find(t => t.id === Number(id)) || {};
};
const getCustomerTeamsResult = state => {
  const _ref3 = state.Teams || {},
    loading = _ref3.loading,
    data = _ref3.data,
    customerTeamsOffset = _ref3.customerTeamsOffset,
    customerTeamsCount = _ref3.customerTeamsCount,
    customerTeamsTotalHits = _ref3.customerTeamsTotalHits;
  return {
    loading,
    data,
    hasMoreData: data.filter(team => team.type === groupTypeNames.PRIVATE).length < customerTeamsTotalHits,
    nextLoading: loading && customerTeamsOffset > 0,
    nextLoadCount: Math.min(customerTeamsCount - customerTeamsOffset, PAGE_SIZE)
  };
};
const selectCustomerTeamsOffset = _ref4 => {
  let Teams = _ref4.Teams;
  return Teams.customerTeamsOffset;
};
const getRetailers = (state, selectFromBrowseGames) => {
  if (selectFromBrowseGames) {
    return selectBrowseGamesResults(state).results;
  }
  return state.Teams.data.filter(team => {
    const isFollowing = team.isFollowing;
    const isRemoved = state.Teams.removedTeams.indexOf(Number(team.id)) !== -1;
    const isRetailer = team.type === 'RETAILER';
    return !isRemoved && isRetailer && isFollowing;
  });
};
const getRetailer = (state, groupId) => getRetailers(state).find(i => i === Number(groupId)) && state.Teams.data.find(t => t.id === Number(groupId)) || {};
const getRetailerTeamsResult = state => {
  const _ref5 = state.Teams || {},
    loading = _ref5.loading,
    data = _ref5.data,
    retailerTeamsOffset = _ref5.retailerTeamsOffset,
    retailerTeamsCount = _ref5.retailerTeamsCount,
    retailerTeamsTotalHits = _ref5.retailerTeamsTotalHits;
  return {
    loading,
    data,
    hasMoreData: data.filter(team => team.type === groupTypeNames.RETAILER).length < retailerTeamsTotalHits,
    nextLoading: loading && retailerTeamsOffset > 0,
    nextLoadCount: Math.min(retailerTeamsCount - retailerTeamsOffset, PAGE_SIZE)
  };
};
const selectRetailerTeamsOffset = _ref6 => {
  let Teams = _ref6.Teams;
  return Teams.retailerTeamsOffset;
};
const selectIsLoading = _ref7 => {
  let Teams = _ref7.Teams;
  return Teams.loading;
};
const selectHasError = _ref8 => {
  let Teams = _ref8.Teams;
  return Teams.error;
};
setGlobal('svs.components.marketplaceData.selectors.teams', {
  selectTeam,
  getTeams,
  getCustomerTeamsResult,
  getRetailer,
  getRetailers,
  getRetailerTeamsResult,
  selectRetailerTeamsOffset,
  selectCustomerTeamsOffset,
  selectIsLoading,
  selectHasError
});

 })(window);